<template>
  <div>
    <Gender :value="profile.gender" @input="$emit('input')" v-if="active" autofocus />
  </div>
</template>

<script>
import Gender from '@/components/candidate/profile/edit/details/Gender'

export default {
  components: { Gender },
  props: { profile: { type: Object, required: true }, active: { type: Boolean, default: false } },
}
</script>
